module.exports = __webpack_public_path__ + "assets/img/Currency2.c9f51c46.png";